import storage from 'redux-persist/lib/storage';
import {
  APP_CHANGE_LANGUAGE,
  APP_GET_LOGO_REQUEST,
  APP_GET_LOGO_REQUEST_SUCCESS,
  APP_GET_LOGO_REQUEST_FAILURE,
  APP_SET_BREAK_POINT, DESKTOP_WIDTH, TABLET, DESKTOP, APP_NAVIGATION_HIDDEN,
} from '../actions/constants/app.constants';


const initialState = {
  idioma: 'es',
  logo: '',
  breakPoint: '',
  navigation: { hidden: false, hiddenHeight: null },
};

export default function appReducer(state = initialState, { type, payload }) {
  switch (type) {
    case APP_CHANGE_LANGUAGE: {
      const { idioma } = payload;
      return {
        ...state,
        idioma,
      };
    }
    case APP_GET_LOGO_REQUEST: {
      return {
        ...state,
        logo: null,
      };
    }
    case APP_GET_LOGO_REQUEST_SUCCESS: {
      return {
        ...state,
        logo: payload,
      };
    }
    case APP_GET_LOGO_REQUEST_FAILURE: {
      return {
        ...state,
        logo: payload,
        error: 'network error',
      };
    }
    case APP_SET_BREAK_POINT: {
      return {
        ...state,
        breakPoint: window.innerWidth <= DESKTOP_WIDTH ? TABLET : DESKTOP,
      };
    }
    case APP_NAVIGATION_HIDDEN: {
      const { hidden, hiddenHeight } = payload;
      return {
        ...state,
        navigation: { hidden, hiddenHeight },
      };
    }
    default:
      return state;
  }
}
